import { useEffect, useState } from "react";
import { ButtonFrame, Card, CardSearch, PageBodyHeader, Table } from "../../component";
import ModalParent from "../../component/modal/ModalParent";
import { generalObj } from "../../constant/object_types";
import { useSelector } from "react-redux";
import { RootState } from "../../redux";
import { checkStoreByStoreIdUserId, dateToSystemTz, exportOrderRequestPdf, fetchOrderRequest, fetchOrderRequestById } from "../../action/generalFunc";
import { useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { PdfSvg } from "../../style/iconStyle";


const statusBadgeColor = (status:string) => {
    switch (status.toLowerCase()) {
        case "approved":
        case "fulfilled": 
            return { backgroundColor: "#E4F7EA", color: "#00983A" };
        case "rejected": return { backgroundColor: "#FCE4E4", color: "#EB212F" };
        default: return { backgroundColor: "#FFF3D6", color: "#B5820B" };
    }
};

// const orderStatusOptions = ["Pending", "Approved", "Rejected"];

const AdminOrderReqPendingList = () => {
    const { supervisor_id, store_id, vendor_id } = useParams();
    const account = useSelector((state:RootState) => state.account);
    const { setModalLoading }: { setModalLoading:Function } = useOutletContext();
    const [orderList, setOrderList] = useState<generalObj[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [storeName, setStoreName] = useState<string>("");
    const [vendorName, setVendorName] = useState<string>("");
    const [viewOrderRequest, setViewOrderRequest] = useState<generalObj | null>(null);
    const [openViewModal, setOpenViewModal] = useState<boolean>(false);
    
    useEffect(() => {
        if (!account || !account.isAuthenticated || !supervisor_id || !store_id || !vendor_id) return;

        const loadForm = async () => {
            setModalLoading(true);
            let params:generalObj = {
                "status": "pending",
                "requested_by": supervisor_id
            };
            const storeResult = await checkStoreByStoreIdUserId(account.token, store_id, vendor_id);
            if (!storeResult) {
                window.history.back();
                setModalLoading(false);
                return;
            }

            setStoreName(`${storeResult.data.store_data.name} - ${storeResult.data.store_data.organization}`);
            setVendorName(storeResult.data.vendor_data.username);
            
            const orderResult = await fetchOrderRequest(account.token, store_id, vendor_id, false, params);
            setOrderList(orderResult || []);
            setModalLoading(false);
        };

        loadForm();
    }, [account, supervisor_id, store_id, vendor_id, setModalLoading]);

    const viewOrderRequestDetail = async (orderRequestId:number|string) => {
        if (!account || !account.isAuthenticated) return;
        setModalLoading(true);
        const orderRequestResult = await fetchOrderRequestById(account.token, orderRequestId);
        if (orderRequestResult) {
            setViewOrderRequest(orderRequestResult);
            setOpenViewModal(true);
        }
        setModalLoading(false);
    };

    const exportOrderRequest = async (orderRequestId:number|string) => {
        if (!account || !account.isAuthenticated) return;
        setModalLoading(true);
        const result = await exportOrderRequestPdf(account.token, orderRequestId);
        if (result && typeof(result) === "object") {
            const aElement = document.createElement('a');
            aElement.setAttribute('download', `order_request_${orderRequestId}.pdf`);
            const href = URL.createObjectURL(result.data);
            aElement.href = href;
            aElement.setAttribute('target', '_blank');
            aElement.click();
            URL.revokeObjectURL(href);
            toast("Order request exported");
        }
        setModalLoading(false);
    };

    return (
        <>
            <PageBodyHeader title="Order Request" desc="Request products for your store"
                inlineChild={<ButtonFrame btn_text="Back" btn_style={{padding:"8px 24px", borderRadius:"8px", border:"1px solid #808280",  backgroundColor:"#808280", color:"#FFF", fontSize:"14px", fontWeight:"600", letterSpacing:"-0.4px"}} onPress={() => window.history.back()} />}
            />
            {/* <h3 style={{marginBottom:"18px", textAlign:"center"}}>{`Create Order Request for ${vendorName.toLocaleUpperCase()} in ${storeName} store`}</h3> */}

            <div style={{marginTop:"30px"}}>
                <Table table_head={["Order Request #", "Products", "Date", "Status", "Action"]} th_class="white" color="#1159AB" thColor="#1159AB" tableSearch={<CardSearch value={searchText} onTextChange={(value) => setSearchText(value)} />} table_title={`Order requests for ${vendorName.toUpperCase()} in ${storeName}`}>
                    <>
                        {orderList.map((order:generalObj, orderIndex:number) => ({
                            key: order.id ?? orderIndex,
                            request_number: order.request_number || order.order_number || order.order_request_number || order.id || orderIndex + 1,
                            product_count: (order.items || []).length,
                            date: dateToSystemTz(order.created_at || order.order_made_date || order.date),
                            status: order.status || order.order_status || "Pending"
                        })).filter((row) => `${row.request_number} ${row.status}`.toLowerCase().includes(searchText.toLowerCase())).map((row) => (
                            <tr key={row.key}>
                                <td>#{row.request_number}</td>
                                <td>{row.product_count}</td>
                                <td>{row.date}</td>
                                <td><span style={{padding:"4px 12px", borderRadius:"12px", fontSize:"12px", fontWeight:"600", ...statusBadgeColor(row.status)}}>{row.status}</span></td>
                                <td>
                                    <div style={{display:"flex", alignItems:"center", gap:"10px"}}>
                                        <button type="button" onClick={() => viewOrderRequestDetail(row.key)} style={{padding:"6px 12px", borderRadius:"6px", border:"1px solid #1159AB", color:"#1159AB", fontWeight:"600"}}>View</button>
                                        <button type="button" onClick={() => exportOrderRequest(row.key)} style={{width:"24px", height:"24px", fontWeight:"600"}}>
                                            <div style={{width:"24px", height:"24px", display:"flex", alignItems:"center", justifyContent:"center"}}>
                                                <PdfSvg />
                                            </div>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </>
                </Table>
            </div>

            <ModalParent visible={openViewModal}>
                <div className="ViewContainer">
                    <div className="input__pop" style={{maxWidth:"600px", width:"90vw"}}>
                        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"24px"}}>
                            <h4>{`Order Request #${viewOrderRequest?.request_number || viewOrderRequest?.order_number || viewOrderRequest?.id || ""}`}</h4>
                            <button type="button" title="Close" onClick={() => setOpenViewModal(false)} style={{fontSize:"22px", padding:"4px 10px"}}>&times;</button>
                        </div>
                        <Card color="#676967" containerCardStyle={{overflow:"auto"}}>
                            <div style={{padding:"20px"}}>
                                <div style={{display:"flex", justifyContent:"space-between", marginBottom:"16px"}}>
                                    <span>{`Date: ${dateToSystemTz(viewOrderRequest?.created_at || viewOrderRequest?.order_made_date || viewOrderRequest?.date)}`}</span>
                                    <span style={{padding:"4px 12px", borderRadius:"12px", fontSize:"12px", fontWeight:"600", ...statusBadgeColor(viewOrderRequest?.status || viewOrderRequest?.order_status || "Pending")}}>{viewOrderRequest?.status || viewOrderRequest?.order_status || "Pending"}</span>
                                </div>
                                <div style={{marginBottom:"16px"}}>
                                    <span>{`Fulfillment Date: ${dateToSystemTz(viewOrderRequest?.fulfillment_at || viewOrderRequest?.fulfilled_at)}`}</span>
                                </div>
                                <table className="tableComponent" style={{width:"100%"}}>
                                    <thead><tr><th className="headerText white">Product</th><th className="headerText white">Quantity</th><th className="headerText white">Unit</th><th className="headerText white">Received Qty</th></tr></thead>
                                    <tbody>
                                        {(viewOrderRequest?.items || []).map((item:generalObj, itemIndex:number) => (
                                            <tr key={item.id || itemIndex}>
                                                <td>{item.product?.name || item.product_name || item.product || "-"}</td>
                                                <td>{item.requested_quantity ?? item.quantity ?? "-"}</td>
                                                <td>{item.unit?.label || item.unit_name || item.unit || "-"}</td>
                                                <td>{item.received_quantity ?? "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Card>
                    </div>
                </div>
            </ModalParent>
        </>
    )
}

export default AdminOrderReqPendingList;